export const educationData = [
    {
        id: 1,
        institution: 'Sacred Heart College',
        course: 'Higher Secondary Education',
        startYear: '2013',
        endYear: '2015'
    },
    {
        id: 2,
        institution: 'Liverpool John Moores University',
        course: 'Foundation Degree: Engineering and Technology',
        startYear: '2015',
        endYear: '2016'
    },
    {
        id: 3,
        institution: 'Liverpool John Moores University',
        course: 'Bachelor of Science (Honours) in Computer Science',
        startYear: '2016',
        endYear: '2019'
    },
]